import React from 'react';

import Typography from '../Typography';
import { InputProps } from './types';

interface RenderCharacterLimitEndAdornmentParams {
  characterLimit: number;
  className?: string;
  value: unknown;
  variant: InputProps['variant'];
}

const CHARACTER_LIMIT_THRESHOLD = 0.8;

export const renderCharacterLimitEndAdornment = (
  params: RenderCharacterLimitEndAdornmentParams,
) => {
  const { characterLimit, className, value, variant } = params;

  if (typeof value !== 'string' || !value.length) {
    return null;
  }

  const showCharacterLimit = value.length >= characterLimit * CHARACTER_LIMIT_THRESHOLD;

  if (!showCharacterLimit) {
    return null;
  }

  return (
    <Typography
      className={className}
      color="text-text-placeholder"
      variant={variant ?? 'body-long-01'}>
      {characterLimit - value.length}
    </Typography>
  );
};
